// i18n
// scroll bar
import "simplebar-react/dist/simplebar.min.css";

// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";

// ----------------------------------------------------------------------
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/lib/integration/react";
// @mui

// redux
import { persistor } from "./redux/store";
// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import { MotionLazyContainer } from "./components/animate";
import ScrollToTop from "./components/scroll-to-top";
import { SettingsProvider } from "./components/settings";
import SnackbarProvider from "./components/snackbar";

// Check our docs
// https://docs.minimals.cc/authentication/js-version

import { AuthProvider } from "./auth/JwtContext";

// ----------------------------------------------------------------------

export default function App() {
  return (
    <AuthProvider>
      <HelmetProvider>
        <PersistGate loading={null} persistor={persistor}>
          <SettingsProvider>
            <BrowserRouter>
              <ScrollToTop />
              <MotionLazyContainer>
                <ThemeProvider>
                  {/* <ThemeSettings> */}
                  <SnackbarProvider>
                    <Router />

                  </SnackbarProvider>
                  {/* </ThemeSettings> */}
                </ThemeProvider>
              </MotionLazyContainer>
            </BrowserRouter>
          </SettingsProvider>
        </PersistGate>
      </HelmetProvider>
    </AuthProvider>
  );
}
